import * as Sentry from '@sentry/nextjs'

import { isExpectedRefusal } from './expected-refusal'

/**
 * The global `MutationCache.onError` (`src/components/providers.tsx`): reports a thrown mutation error
 * to Sentry and, in development, the console. apiCall never throws (it returns ActionResult), so this
 * only fires for mutations using raw fetch or other throwing patterns. Error feedback is each
 * mutation's responsibility (useStandardMutation or an explicit onError) — no global toast here, to
 * avoid double-toasting. A designed refusal (`isExpectedRefusal`) is expected behaviour: skipped.
 */
export function reportMutationError(error: unknown): void {
  if (isExpectedRefusal(error)) return
  Sentry.captureException(error, { tags: { area: 'mutation-cache' } })
  if (process.env.NODE_ENV === 'development') {
    console.error('[mutation error]', error)
  }
}
